import { render } from "./FsActionsSheet.vue?vue&type=template&id=704fa33f&scoped=true"
import script from "./FsActionsSheet.vue?vue&type=script&lang=js"
export * from "./FsActionsSheet.vue?vue&type=script&lang=js"

import "./FsActionsSheet.vue?vue&type=style&index=0&id=704fa33f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704fa33f"]])

export default __exports__